import React, { Component, useContext, useEffect } from "react";
import wooCommerceLogo from "../../../../assets/images/woocommerce/woocommerce-logo.svg";
import wooCommerceLightLogo from "../../../../assets/images/woocommerce/woocommerce-logo-light.svg";
import IErrorDTO from "../../../../models/DTO/IErrorDTO";
import IGetCatalogsDTO from "../../../../models/DTO/IGetCatalogsDTO";
import IGetPriceGroupsDTO from "../../../../models/DTO/IGetPriceGroupsDTO";
import ILoadDashboardDTO from "../../../../models/DTO/ILoadDashboardDTO";
import ILoadUserDTO from "../../../../models/DTO/ILoadUserDTO";
import IOnGetCatalogsDTO from "../../../../models/DTO/IOnGetCatalogsDTO";
import IOnGetPriceGroupsDTO from "../../../../models/DTO/IOnGetPriceGroupsDTO";
import IOnWooCommerceInitializeDTO from "../../../../models/DTO/IOnWooCommerceInitializeDTO";
import IOnWooCommerceValidationDTO from "../../../../models/DTO/IOnWooCommerceValidationDTO";
import IUpdateSupplierIntegrationsDTO from "../../../../models/DTO/IUpdateSupplierIntegrationsDTO";
import IWooCommerceInitializeDTO from "../../../../models/DTO/IWooCommerceInitializeDTO";
import IWooCommerceValidationDTO from "../../../../models/DTO/IWooCommerceValidationDTO";
import EndpointsEnum from "../../../../models/EndpointsEnum";
import ICatalog from "../../../../models/ICatalog";
import INotification from "../../../../models/INotification";
import IntegrationDeleteOptionEnum from "../../../../models/IntegrationDeleteOptionEnum";
import IntegrationDirectionOptionEnum from "../../../../models/IntegrationDirectionOptionEnum";
import IOwOption from "../../../../models/IOwOption";
import IPrice_Group from "../../../../models/IPrice_Group";
import ISupplierModel from "../../../../models/ISupplierModel";
import IUserUI from "../../../../models/IUserUI";
import IWooCommerceOptions from "../../../../models/IWooCommerceOptions";
import NotificationLevelEnum from "../../../../models/NotificationLevelEnum";
import NotificationPositionEnum from "../../../../models/NotificationPositionEnum";
import { OwAccordion } from "../../../shared/OwAccordion/OwAccordion";
import OwButton from "../../../shared/OwButton/OwButton";
import OwInputWrapper from "../../../shared/OwInputWrapper/OwInputWrapper";
import OwLabel from "../../../shared/OwLabel/OwLabel";
import OwSelectOption from "../../../shared/OwSelectOption/OwSelectOption";
import OwToggle from "../../../shared/OwToggle/OwToggle";
import WhatsThis from "../../../shared/WhatsThis/WhatsThis";
import { Socket } from "socket.io-client";
import SupplierContext from "../../../../contexts/SupplierContext";
import UserContext from "../../../../contexts/UserContext";
import IUiSocketSetup from "../../../../models/IUiSocketSetup";
import { SocketContext } from "../../../../contexts/SocketContext";
import UiContext from "../../../../contexts/UiContext";
import UIService from "../../../../services/UIService";

type Props = {};

export const WooCommerceConnect = (props: Props) => {
    const supplierModel = useContext(SupplierContext);
    const userModel = useContext(UserContext);
    const socket = useContext(SocketContext);
    const uiContext = useContext(UiContext);

    const [isUpdating, setIsUpdating] = React.useState<boolean>(false);
    const [wooCommerceKey, setWooCommerceKey] = React.useState<string>(supplierModel.Supplier_Integration.woocommerce_key || "");
    const [wooCommerceSecret, setWooCommerceSecret] = React.useState<string>(supplierModel.Supplier_Integration.woocommerce_secret || "");
    const [wooCommerceServerUrl, setWooCommerceServerUrl] = React.useState<string>(
        supplierModel.Supplier_Integration.woocommerce_server_url || ""
    );
    const [woocommerceOptions, setWooCommerceOptions] = React.useState<IWooCommerceOptions>(
        supplierModel.Supplier_Integration.woocommerce_options || ({} as IWooCommerceOptions)
    );
    const [saveActive, setSaveActive] = React.useState<boolean>(false);
    const [activeSetupWebhooks, setActiveSetupWebhooks] = React.useState<boolean>(false);
    const [activeValidateApiAccess, setActiveValidateApiAccess] = React.useState<boolean>(false);
    const [validationError, setValidationError] = React.useState<boolean>(false);
    const [webHookSetupError, setWebHookSetupError] = React.useState<boolean>(false);
    const [inventoryUpdateOptions, setInventoryUpdateOptions] = React.useState<IOwOption[]>([
        { value: IntegrationDirectionOptionEnum.BOTH, title: "Both" },
        { value: IntegrationDirectionOptionEnum.UPSTREAM, title: "Upstream" },
        { value: IntegrationDirectionOptionEnum.DOWNSTREAM, title: "Downstream" },
        { value: IntegrationDirectionOptionEnum.NONE, title: "None" },
    ]);
    const [productChangesOptions, setProductChangesOptions] = React.useState<IOwOption[]>([
        { value: IntegrationDirectionOptionEnum.BOTH, title: "Both" },
        { value: IntegrationDirectionOptionEnum.UPSTREAM, title: "Upstream" },
        { value: IntegrationDirectionOptionEnum.DOWNSTREAM, title: "Downstream" },
        { value: IntegrationDirectionOptionEnum.NONE, title: "None" },
    ]);
    const [onDelete, setOnDelete] = React.useState<IOwOption[]>([
        { value: IntegrationDeleteOptionEnum.DEACTIVATE, title: "Deactivate" },
        { value: IntegrationDeleteOptionEnum.IGNORE, title: "Ignore" },
    ]);
    const [priceGroups, setPriceGroups] = React.useState<IPrice_Group[]>([]);
    const [catalogs, setCatalogs] = React.useState<ICatalog[]>([]);

    const getPriceGroups = () => {
        // console.log("catalogs", this.state.catalogs);
        const catalogModel = catalogs.find((catalog) => {
            return catalog.id === Number(woocommerceOptions.default_catalog_id);
        });

        // console.log("found catalogModel", catalogModel);

        if (catalogModel) {
            const payload: IGetPriceGroupsDTO = {
                userGuid: userModel.guid,
                userToken: userModel.token,
                supplierGuid: supplierModel.guid,
                catalogGuid: catalogModel.guid,
            };

            socket?.emit(EndpointsEnum.CatalogsGetPriceGroups, payload);
        }
    };

    useEffect(() => {
        if (supplierModel.Supplier_Integration.woocommerce_options?.default_catalog_id) {
            getPriceGroups();
        }
    }, [catalogs]);

    const onGetCatalogs = (data: IOnGetCatalogsDTO) => {
        setCatalogs(data.catalogs);
    };

    const onGetPriceGroups = (data: IOnGetPriceGroupsDTO) => {
        setPriceGroups(data.priceGroups);
    };

    const getCatalogs = () => {
        const payload: IGetCatalogsDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
            callMeta: {
                view: "WooCommerceConnect",
                fn: "getCatalogs",
            },
        };

        socket?.emit(EndpointsEnum.CatalogsGetCatalogs, payload);
    };

    const onUpdateSupplierIntegrations = (data: IUpdateSupplierIntegrationsDTO) => {
        if (isUpdating) {
            const notification: INotification = {
                level: NotificationLevelEnum.success,
                message: "updated_woocommerce_integration",
                position: NotificationPositionEnum.bc,
            };

            uiContext.notifyFn(null, notification);

            // TODO after updating the integration, reload the supplier
            // loadSupplier();
            // this.setState(
            //     {
            //         updating: false,
            //         saveActive: false,
            //     },
            //     () => {
            //         let payload: ILoadUserDTO = {
            //             userGuid: userModel.guid,
            //             userToken: userModel.token,
            //         };
            //
            //         socket?.emit(EndpointsEnum.AppLoadUser, payload);
            //     }
            // );
        }

        setIsUpdating(false);
        setSaveActive(false);
    };

    const onWooCommerceValidation = (data: IOnWooCommerceValidationDTO) => {
        if (data.isValid) {
            const notification: INotification = {
                level: NotificationLevelEnum.success,
                message: "successfully_validated_woocommerce_details",
                position: NotificationPositionEnum.bc,
            };

            uiContext.notifyFn(null, notification);
        }

        setValidationError(!data.isValid);
        setActiveValidateApiAccess(false);
    };

    const onWooCommerceInitialize = (data: IOnWooCommerceInitializeDTO) => {
        if (data.isSetup) {
            const notification: INotification = {
                level: NotificationLevelEnum.success,
                message: "successfully_setup_woocommerce_webhooks",
                position: NotificationPositionEnum.bc,
            };

            uiContext.notifyFn(null, notification);
        }

        setWebHookSetupError(!data.isSetup);
        setActiveSetupWebhooks(false);
    };

    const toggleWooCommerce = (e: any) => {
        const name = e.target.name;
        const value = e.target.value;

        const payload: IUpdateSupplierIntegrationsDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
            // @ts-expect-error
            Supplier_Integration: {
                has_woocommerce: value,
            },
        };

        socket?.emit(EndpointsEnum.SupplierUpdateSupplierIntegrations, payload);

        setIsUpdating(true);
    };

    const updateSupplierIntegration = (e: any) => {
        const name = e.target.name;
        const value = e.target.value;

        const secret = wooCommerceSecret;

        const payload: IUpdateSupplierIntegrationsDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
            // @ts-expect-error
            Supplier_Integration: {
                woocommerce_key: wooCommerceKey,
                woocommerce_server_url: wooCommerceServerUrl,
            },
        };

        if (secret && secret.length > 4) {
            payload.Supplier_Integration.woocommerce_secret = secret;
        }

        socket?.emit(EndpointsEnum.SupplierUpdateSupplierIntegrations, payload);

        setSaveActive(true);
        setIsUpdating(true);
    };

    const updateWooCommerceOptions = (e: any) => {
        const name = e.target.name;
        const value = e.target.value;

        const secret = wooCommerceSecret;

        const payload: IUpdateSupplierIntegrationsDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
            // @ts-expect-error
            Supplier_Integration: {
                woocommerce_options: woocommerceOptions,
            },
        };

        socket?.emit(EndpointsEnum.SupplierUpdateSupplierIntegrations, payload);

        setSaveActive(true);
        setIsUpdating(true);
    };

    const notify = (data: INotification) => {
        setSaveActive(false);
        setIsUpdating(false);
        setActiveValidateApiAccess(false);
        setActiveSetupWebhooks(false);
    };

    const sockets: IUiSocketSetup[] = [
        { endpoint: EndpointsEnum.SupplierOnUpdateSupplierIntegrations, fn: onUpdateSupplierIntegrations },
        { endpoint: EndpointsEnum.WooCommerceOnValidation, fn: onWooCommerceValidation },
        { endpoint: EndpointsEnum.WooCommerceOnInitialize, fn: onWooCommerceInitialize },
        { endpoint: EndpointsEnum.CatalogsOnGetCatalogs, fn: onGetCatalogs },
        { endpoint: EndpointsEnum.CatalogsOnGetPriceGroups, fn: onGetPriceGroups },
        { endpoint: EndpointsEnum.Notify, fn: notify },
    ];

    useEffect(() => {
        for (const _socket of sockets) {
            socket?.on(_socket.endpoint, _socket.fn);
        }

        getCatalogs();

        return () => {
            for (const _socket of sockets) {
                socket?.removeListener(_socket.endpoint, _socket.fn);
            }
        };
    }, []);

    // componentDidMount(): void {
    //     socket?.on(EndpointsEnum.SupplierOnUpdateSupplierIntegrations, this.onUpdateSupplierIntegrations);
    //     socket?.on(EndpointsEnum.WooCommerceOnValidation, this.onWooCommerceValidation);
    //     socket?.on(EndpointsEnum.WooCommerceOnInitialize, this.onWooCommerceInitialize);
    //     socket?.on(EndpointsEnum.CatalogsOnGetCatalogs, this.onGetCatalogs);
    //     socket?.on(EndpointsEnum.CatalogsOnGetPriceGroups, this.onGetPriceGroups);
    //
    //     this.getCatalogs();
    // }
    //
    // componentWillUnmount(): void {
    //     socket?.removeListener(EndpointsEnum.SupplierOnUpdateSupplierIntegrations, this.onUpdateSupplierIntegrations);
    //     socket?.removeListener(EndpointsEnum.WooCommerceOnValidation, this.onWooCommerceValidation);
    //     socket?.removeListener(EndpointsEnum.WooCommerceOnInitialize, this.onWooCommerceInitialize);
    //     socket?.removeListener(EndpointsEnum.CatalogsOnGetCatalogs, this.onGetCatalogs);
    //     socket?.removeListener(EndpointsEnum.CatalogsOnGetPriceGroups, this.onGetPriceGroups);
    // }

    const handleSettingsChange = (e: any) => {
        const name = e.target.name;
        const value = e.target.value;

        const options = woocommerceOptions;

        // @ts-expect-error
        options[name] = value;

        const state: any = {
            woocommerce_options: options,
        };

        setWooCommerceOptions(options);

        if (name === "default_catalog_id") {
            getPriceGroups();
        }
    };

    const handleChange = (e: any) => {
        const name = e.target.name;
        const value = e.target.value;

        switch (name) {
            case "woocommerce_key":
                setWooCommerceKey(value);
                break;

            case "woocommerce_secret":
                setWooCommerceSecret(value);
                break;

            case "woocommerce_server_url":
                setWooCommerceServerUrl(value);
                break;
        }
    };

    const setupWebhooks = () => {
        const payload: IWooCommerceInitializeDTO = {
            userToken: userModel.token,
            userGuid: userModel.guid,
            supplierGuid: supplierModel.guid,
        };

        socket?.emit(EndpointsEnum.WooCommerceInitialize, payload);

        setActiveSetupWebhooks(true);
    };

    const validateApiAccess = () => {
        const payload: IWooCommerceValidationDTO = {
            userToken: userModel.token,
            userGuid: userModel.guid,
            supplierGuid: supplierModel.guid,
        };

        socket?.emit(EndpointsEnum.WooCommerceValidation, payload);

        setActiveValidateApiAccess(true);
    };

    const getInventoryUpdatesText = () => {
        if (woocommerceOptions) {
            switch (woocommerceOptions.inventory_updates) {
                case IntegrationDirectionOptionEnum.BOTH:
                    return `Inventory Updates from WooCommerce will change Orderwerks, and Inventory Updates from Orderwerks will change WooCommerce.`;

                case IntegrationDirectionOptionEnum.UPSTREAM:
                    return `Inventory Updates from Orderwerks will change WooCommerce, changes from WooCommerce will be ignored.`;

                case IntegrationDirectionOptionEnum.DOWNSTREAM:
                    return `Inventory Updates from WooCommerce will change Orderwerks, changes from Orderwerks will be ignored.`;

                case IntegrationDirectionOptionEnum.NONE:
                    return `Inventory Updates from both WooCommerce and/or Orderwerks will not change the other platform.`;
            }
        }
    };

    const getProductChangesText = () => {
        if (woocommerceOptions) {
            switch (woocommerceOptions.product_changes) {
                case IntegrationDirectionOptionEnum.BOTH:
                    return `Products Created/Updated from WooCommerce will change Orderwerks, and Products Created/Updated from Orderwerks will change WooCommerce.`;

                case IntegrationDirectionOptionEnum.UPSTREAM:
                    return `Products Created/Updated from Orderwerks will change WooCommerce, changes from WooCommerce will be ignored.`;

                case IntegrationDirectionOptionEnum.DOWNSTREAM:
                    return `Products Created/Updated from WooCommerce will change Orderwerks, changes from Orderwerks will be ignored.`;

                case IntegrationDirectionOptionEnum.NONE:
                    return `Products Created/Delete from WooCommerce and/or Orderwerks will not change the other platform.`;
            }
        }
    };

    const getOnDeleteText = () => {
        if (woocommerceOptions) {
            switch (woocommerceOptions.on_delete) {
                case IntegrationDeleteOptionEnum.IGNORE:
                    return `Product Deletions from WooCommerce will be ignored.`;

                case IntegrationDeleteOptionEnum.DEACTIVATE:
                    return `Product Deletions from WooCommerce will Deactivate Catalog Items in Orderwerks`;
            }
        }
    };

    const getIntegrationDetails = () => {
        if (!supplierModel.Supplier_Integration.has_woocommerce) {
            return null;
        } else {
            let isSetup = false;

            if (wooCommerceSecret && wooCommerceSecret === "true") {
                isSetup = true;
            }

            return (
                <div className={"mt-4 w-100 mb-4"}>
                    {validationError ? (
                        <div>
                            <OwLabel
                                className={"text-danger"}
                                leftIconClass={"fad fa-circle-times"}
                                title={"error_validating_connection_contact_support"}
                            />
                        </div>
                    ) : null}

                    {webHookSetupError ? (
                        <div>
                            <OwLabel
                                className={"text-danger"}
                                leftIconClass={"fad fa-circle-times"}
                                title={"error_setting_up_webhooks_contact_support"}
                            />
                        </div>
                    ) : null}

                    <div>
                        <OwLabel title={"woocommerce_server_url"} noBottomMargin={true} />
                        <OwInputWrapper name={"woocommerce_server_url"} fn={handleChange} value={wooCommerceServerUrl} />
                    </div>

                    <div className={"mt-4"}>
                        <OwLabel title={"woocommerce_key"} noBottomMargin={true} />
                        <OwInputWrapper name={"woocommerce_key"} fn={handleChange} value={wooCommerceKey} />
                    </div>

                    <div className={"mt-4"}>
                        <div>
                            <OwLabel title={"woocommerce_secret"} noBottomMargin={true} />
                        </div>
                        <OwInputWrapper
                            type={"password"}
                            name={"woocommerce_secret"}
                            fn={handleChange}
                            value={wooCommerceSecret !== "true" ? wooCommerceSecret : ""}
                        />
                        {isSetup ? (
                            <div>
                                <div>
                                    <OwLabel className={"text-success"} leftIconClass={"fad fa-check-circle"} title={"secret_saved"} />
                                    <WhatsThis subject={"whats_this_woocommerce_secret"} />
                                </div>
                            </div>
                        ) : null}
                    </div>

                    <div className={"mt-3"}>
                        <OwButton fn={updateSupplierIntegration} title={"save"} active={saveActive} disableOnActive={true} />
                    </div>

                    {isSetup ? (
                        <div className={"mt-4"}>
                            <div className={"mb-4"}>
                                <div className={"mb-2"}>
                                    <OwLabel title={"inventory_updates"} />
                                    <div>
                                        <OwSelectOption
                                            valueProp={"value"}
                                            titleProp={"title"}
                                            name={"inventory_updates"}
                                            selectedOption={woocommerceOptions}
                                            selectedOptionProp={"inventory_updates"}
                                            options={inventoryUpdateOptions}
                                            fn={handleSettingsChange}
                                        />
                                    </div>
                                    <p className={"mt-3 ms-2 text-small text-muted"}>{getInventoryUpdatesText()}</p>
                                </div>

                                <div className={"mb-2"}>
                                    <OwLabel title={"product_changes"} />
                                    <div>
                                        <OwSelectOption
                                            valueProp={"value"}
                                            titleProp={"title"}
                                            name={"product_changes"}
                                            selectedOption={woocommerceOptions}
                                            selectedOptionProp={"product_changes"}
                                            options={productChangesOptions}
                                            fn={handleSettingsChange}
                                        />
                                    </div>
                                    <p className={"mt-3 ms-2 text-small text-muted"}>{getProductChangesText()}</p>
                                </div>

                                {/*{(woocommerceOptions &&*/}
                                {/*    woocommerceOptions.product_changes === IntegrationDirectionOptionEnum.BOTH) ||*/}
                                {/*(woocommerceOptions &&*/}
                                {/*    woocommerceOptions.product_changes === IntegrationDirectionOptionEnum.DOWNSTREAM) ? (*/}
                                <div>
                                    <div className={"mb-2"}>
                                        <OwLabel title={"default_catalog"} />
                                        <div>
                                            <OwSelectOption
                                                valueProp={"id"}
                                                titleProp={"name"}
                                                name={"default_catalog_id"}
                                                selectedOption={woocommerceOptions}
                                                selectedOptionProp={"default_catalog_id"}
                                                options={catalogs}
                                                fn={handleSettingsChange}
                                            />
                                        </div>
                                    </div>
                                </div>
                                {/*) : null}*/}

                                {/*{(woocommerceOptions &&*/}
                                {/*    woocommerceOptions.product_changes === IntegrationDirectionOptionEnum.BOTH) ||*/}
                                {/*(woocommerceOptions &&*/}
                                {/*    woocommerceOptions.product_changes === IntegrationDirectionOptionEnum.UPSTREAM) ? (*/}
                                <div>
                                    <div className={"mb-2"}>
                                        <OwLabel title={"regular_price_price_group"} />

                                        <div>
                                            <OwSelectOption
                                                valueProp={"id"}
                                                titleProp={"value"}
                                                name={"regular_price_price_group_id"}
                                                selectedOption={woocommerceOptions}
                                                selectedOptionProp={"regular_price_price_group_id"}
                                                options={priceGroups}
                                                fn={handleSettingsChange}
                                            />
                                        </div>
                                    </div>

                                    <div className={"mb-2"}>
                                        <OwLabel title={"sale_price_price_group"} />

                                        <div>
                                            <OwSelectOption
                                                valueProp={"id"}
                                                titleProp={"value"}
                                                name={"sale_price_price_group_id"}
                                                selectedOption={woocommerceOptions}
                                                selectedOptionProp={"sale_price_price_group_id"}
                                                options={priceGroups}
                                                fn={handleSettingsChange}
                                            />
                                        </div>
                                    </div>
                                </div>
                                {/*) : null}*/}

                                <div className={"mb-2"}>
                                    <OwLabel title={"on_delete"} />
                                    <div>
                                        <OwSelectOption
                                            valueProp={"value"}
                                            titleProp={"title"}
                                            name={"on_delete"}
                                            selectedOption={woocommerceOptions}
                                            selectedOptionProp={"on_delete"}
                                            options={onDelete}
                                            fn={handleSettingsChange}
                                        />
                                    </div>
                                    <p className={"mt-3 ms-2 text-small text-muted"}>{getOnDeleteText()}</p>
                                </div>

                                <div className={"mt-3"}>
                                    <OwButton fn={updateWooCommerceOptions} title={"save"} active={saveActive} disableOnActive={true} />
                                </div>
                            </div>
                            <div>
                                <OwButton
                                    title={"validate_woocommerce_api"}
                                    fn={validateApiAccess}
                                    active={activeValidateApiAccess}
                                    disableOnActive={true}
                                />
                            </div>
                            <div className={"mt-2"}>
                                <OwButton title={"setup_webhooks"} fn={setupWebhooks} active={activeSetupWebhooks} disableOnActive={true} />
                            </div>
                        </div>
                    ) : null}
                </div>
            );
        }
    };

    const integrationDetails = getIntegrationDetails();

    let logo = wooCommerceLogo;

    if (UIService.isMainViewLight()) {
        logo = wooCommerceLightLogo;
    }

    const hasWooCommerce = !!supplierModel.Supplier_Integration.has_woocommerce;

    return (
        <div className="WooCommerceConnect">
            <OwAccordion
                hideChevron={!hasWooCommerce}
                leftImage={logo}
                leftImageAlt={"WooCommerce"}
                leftImageHeight={30}
                titleClick={hasWooCommerce}
                rightElem={
                    <div className={"ms-auto h-2r"}>
                        <OwToggle fn={toggleWooCommerce} name={"has_woocommerce"} label={""} active={hasWooCommerce} />
                    </div>
                }>
                <div className={"w-15r"}>{integrationDetails}</div>
            </OwAccordion>
        </div>
    );
};

export default WooCommerceConnect;
